module.exports = __webpack_public_path__ + "static/media/tablet-features-img.2f4c6b8a.svg";